(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buttr-closing-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ccta]').forEach(function (el) {
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        return;
      }
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.2 }).observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buttr-collage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-clg]').forEach(function (el) {
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        return;
      }
      new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-in');
            obs.unobserve(e.target);
          });
        },
        { threshold: 0.15 }
      ).observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buttr-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* The hover sweep is entirely CSS (see @keyframes cmpSweep). All this does
       is hand control to the visitor the first time they touch the slider, and
       keep --compare in step with the input after that. */
    document.querySelectorAll('[data-cmp]').forEach(function (root) {
      var stage = root.querySelector('[data-cmp-stage]');
      var range = root.querySelector('[data-cmp-range]');
      if (!stage || !range) return;

      function paint() {
        stage.style.setProperty('--compare', String(Number(range.value)));
      }

      /* .is-manual kills the sweep for good. Anything less and the animation
         would fight the handle the visitor is holding. */
      function surrender() {
        stage.classList.add('is-manual');
        paint();
      }

      range.addEventListener('pointerdown', surrender);
      range.addEventListener('keydown', surrender);
      range.addEventListener('input', surrender);

      paint();

      /* One-shot sweep the first time it scrolls into view, so the interaction
         is discoverable without the visitor having to guess it is draggable. */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            stage.classList.add('is-seen');
            io.disconnect();
          });
        }, { threshold: 0.4 });
        io.observe(stage);
      } else {
        stage.classList.add('is-seen');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buttr-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rvw]').forEach(function (el) {
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        return;
      }
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.2 }).observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery-partners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-dlv]').forEach(function (band) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              band.classList.add('is-in');
              obs.unobserve(band);
            });
          },
          { threshold: 0.2 }
        ).observe(band);
      } else {
        band.classList.add('is-in');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifting-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gft]').forEach(function (el) {
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        return;
      }
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.2 }).observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-hero-media]').forEach(function (media) {
      var layers = Array.prototype.slice.call(media.querySelectorAll('[data-layer]'));
      var pool;
      try {
        pool = JSON.parse(media.getAttribute('data-pool') || '[]');
      } catch (e) {
        pool = [];
      }

      /* ---- rotation ----------------------------------------------------
         `taken` holds the pool index each layer is currently showing. A layer
         may only move to an index absent from that set, so two layers can never
         display the same photograph simultaneously. Needs more pool items than
         layers; below that we leave the seeded images static rather than
         flicker between duplicates. */
      if (pool.length > layers.length && !reduce.matches) {
        var taken = {};

        layers.forEach(function (layer, i) {
          layer._idx = i;
          taken[i] = true;
        });

        layers.forEach(function (layer, i) {
          var imgs = layer.querySelectorAll('.hero-ed__img');
          if (imgs.length < 2) return;
          var period = parseInt(layer.getAttribute('data-period'), 10) || 6000;
          var showingFirst = true;

          function step() {
            var next = layer._idx;
            /* Walk forward to the next index nobody else holds. */
            for (var n = 1; n <= pool.length; n++) {
              var cand = (layer._idx + n) % pool.length;
              if (!taken[cand]) {
                next = cand;
                break;
              }
            }
            if (next === layer._idx) return;

            delete taken[layer._idx];
            taken[next] = true;
            layer._idx = next;

            var incoming = showingFirst ? imgs[1] : imgs[0];
            var outgoing = showingFirst ? imgs[0] : imgs[1];
            incoming.src = pool[next];
            /* Only crossfade once the new frame has actually decoded, so the
               outgoing image never fades to an empty box. */
            var swap = function () {
              incoming.classList.add('is-on');
              outgoing.classList.remove('is-on');
              showingFirst = !showingFirst;
            };
            if (incoming.decode) {
              incoming.decode().then(swap).catch(swap);
            } else {
              incoming.onload = swap;
            }
          }

          /* Stagger the first tick as well as the interval, so the layers never
             fall into step with one another. */
          setTimeout(function () {
            step();
            setInterval(step, period);
          }, 1400 + i * 900);
        });
      }

      /* ---- scroll parallax --------------------------------------------- */
      if (reduce.matches) return;
      var moving = media.querySelectorAll('[data-depth]');
      if (!moving.length) return;

      var ticking = false;
      function update() {
        ticking = false;
        var r = media.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / (window.innerHeight / 2 + r.height / 2);
        moving.forEach(function (el) {
          var depth = parseFloat(el.getAttribute('data-depth')) || 0;
          el.style.setProperty('--hero-py', (p * depth).toFixed(2) + 'px');
        });
      }

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-its-made"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-him]').forEach(function (el) {

      /* Shopify's video_tag emits its poster <img> with no alt attribute, which
         screen readers announce as an unlabelled image. These loops are ambient
         B-roll with the category text right beside them, so mark them
         decorative rather than inventing a description. */
      el.querySelectorAll('video img:not([alt])').forEach(function (img) {
        img.setAttribute('alt', '');
      });
      if (reduce) {
        el.querySelectorAll('video').forEach(function (v) {
          v.autoplay = false;
          v.removeAttribute('autoplay');
          v.pause();
        });
      }
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        return;
      }
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.12 }).observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["range-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rex]').forEach(function (rex) {
      var tabs = Array.prototype.slice.call(rex.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(rex.querySelectorAll('[role="tabpanel"]'));
      if (tabs.length < 2) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Shopify's video_tag emits its poster <img> with no alt attribute, which
         screen readers announce as an unlabelled image. These loops are ambient
         B-roll with the category text right beside them, so mark them
         decorative rather than inventing a description. */
      rex.querySelectorAll('video img:not([alt])').forEach(function (img) {
        img.setAttribute('alt', '');
      });

      /* Autoplaying loops are exactly what reduced-motion users opt out of, so
         freeze them on the first frame instead of removing the media. */
      if (reduce) {
        rex.querySelectorAll('video').forEach(function (v) {
          v.autoplay = false;
          v.removeAttribute('autoplay');
          v.pause();
        });
      }

      function select(index, focusTab) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          /* Roving tabindex: only the active tab is in the tab order, so the
             tablist is one stop rather than four. */
          tab.tabIndex = on ? 0 : -1;
          tab.classList.toggle('is-on', on);
        });

        panels.forEach(function (panel, i) {
          if (i === index) {
            panel.hidden = false;
            if (!reduce) {
              panel.classList.add('is-swapping');
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  panel.classList.remove('is-swapping');
                });
              });
            }
          } else {
            panel.hidden = true;
            panel.classList.remove('is-swapping');
          }
        });

        if (focusTab) tabs[index].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i, false);
        });
      });

      rex.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
        var current = tabs.indexOf(document.activeElement);
        if (current === -1) return;
        var next = null;
        if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        select(next, true);
      });
    });
  })();

  /* add-to-cart + buy-now (client 2026-08-12). AJAX add so the homepage isn't
     reloaded; add-to-cart updates the cart count and tries to open the drawer,
     buy-now goes to checkout. Any failure falls back to a real form POST. */
  (function () {
    function refreshCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document
            .querySelectorAll('[ref="cartBubbleText"], .cart-bubble__text, .cart-count, [data-cart-count]')
            .forEach(function (el) { el.textContent = c.item_count; });
          var bubble = document.querySelector('.cart-bubble');
          if (bubble) { bubble.removeAttribute('hidden'); }
          try {
            var drawer = document.querySelector('cart-drawer, cart-drawer-component');
            if (drawer) {
              if (typeof drawer.showDialog === 'function') drawer.showDialog();
              else if (typeof drawer.open === 'function') drawer.open();
              else if (typeof drawer.show === 'function') drawer.show();
            }
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
    }

    document.querySelectorAll('[data-rex-add], [data-rex-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var id = btn.getAttribute('data-variant');
        var isBuy = btn.hasAttribute('data-rex-buy');
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (isBuy) { window.location.href = '/checkout'; return; }
            btn.textContent = 'added ✓';
            refreshCart();
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
          })
          .catch(function () { btn.textContent = orig; btn.disabled = false; btn.closest('form').submit(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
